import { Pipe, PipeTransform } from '@angular/core';
import { ResultDu } from '../../entity/result-du';

@Pipe({name: 'not_excluded_filter'})
export class NotExcludedResultsFilterPipe implements PipeTransform {
    transform(items: ResultDu[]): any {
        if (!items) {
            return items;
        }
        // filter items array, items which match and return true will be kept, false will be filtered out
        return items.filter(item => this.match(item));
    }

    match(item: ResultDu): boolean {
        return !item.calculationExcluded && !item.du.solutionCode.includes("INH");
    }
}


// WEBPACK FOOTER //
// ./src/app/shared/pipes/not-excluded-results-filter.pipe.ts